import { render, staticRenderFns } from "./WalletConnector.vue?vue&type=template&id=3c81a922&scoped=true"
import script from "./WalletConnector.vue?vue&type=script&lang=js"
export * from "./WalletConnector.vue?vue&type=script&lang=js"
import style0 from "./WalletConnector.vue?vue&type=style&index=0&id=3c81a922&prod&scoped=true&lang=css"
import style1 from "./WalletConnector.vue?vue&type=style&index=1&id=3c81a922&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81a922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VDialog,VIcon,VImg,VLayout})
